import { IProductIndexModel } from '../../catalog/productIndexCard/IProductItemModel';
import HomeBaseComponent, { IHomeBaseProps, IHomeBaseState } from '../homePage/HomeBaseComponent';
import * as style from './style.css';
import * as homeStyle from '../homePage/style.css';
import { ProductIndexCard } from '../../catalog/productIndexCard/ProductIndexCard';
import React = require('react');

export interface IProps extends IHomeBaseProps {
    url: string;
    title: string;
}

interface IState extends IHomeBaseState {
    models: IProductIndexModel[];

}

export default class Recomended extends HomeBaseComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            models: []
        };
    }

    protected getUriHomeData() {
        return this.props.url;
    }

    protected onDataChanged(data: IProductIndexModel[]) {
        this.setState({ models: data });
    }

    renderView() {
        return (<div className={homeStyle.hotItems}>
            <div className={homeStyle.sectionTitle} >
                {this.props.title}
            </div>
            <div className={homeStyle.sectionBar}></div>
            <div className={style.items}>

                {this.state.models.length > 0 &&
                this.state.models.map((p) =>
                    <ProductIndexCard
                        key={p.uri}
                        item={p}
                        buyClick={(id, name) => this.handleItemBuy(id, name)}
                    />

                )}
            </div>

        </div>);
    }
}
